import {notDefined} from "../../libs/utils/epic.utils";

export class DataUrl {

  public readonly mimeType: string;
  public readonly base64: string;
  public readonly dataUrl: string;

  private constructor(mimeType: string, base64: string, dataUrl: string) {
    this.mimeType = mimeType;
    this.base64 = base64;
    this.dataUrl = dataUrl;
  }

  public static parse(dataUrl: string): DataUrl {
    const match = dataUrl.match(/^data:(.+?\/.+?)(;base64)?,(.*)$/);
    if (notDefined(match)) {
      throw new Error('Invalid data URL format');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_ignored, mimeType, encodingFlag, base64Data] = match;
    const base64 = encodingFlag ? base64Data : encodeURIComponent(base64Data);
    return new DataUrl(mimeType, base64, dataUrl);
  }
}
